import mapExtraItemProperties from '../shared/map-extra-item-properties'

export default function(config, order, analytics) {
    const items = []

    for (let item of order.items.data) {
        const product = item.product.data
        if (!config.excluded_product_types.includes(product.type)) {
            items.push({
                item_id: product.id,
                item_name: product.name,
                item_category: product.type,
                price: item.single_price,
                quantity: item.count || 1,
                ...mapExtraItemProperties(item.extra),
            })
        }
    }

    let coupons = null
    if (order.discounts) {
        coupons = order.discounts.data
        .filter(discount => discount.type == 'coupon')
        .map(discount => discount.options.code)
        .join(', ')
    }

    analytics.track('purchase', {
        ecommerce: {
            transaction_id: order.invoice_number,
            value: order.total,
            tax: order.tax - order.tax_discount,
            currency: 'USD',
            coupon: coupons,
            items,
        },
    })
}
